import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React from 'react';

interface DialogProps {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

const StopContactDialog = ({ open, onSubmit, onCancel }: DialogProps) => {
  return (
    <Dialog open={open} aria-labelledby="stop-contact-dialog">
      <DialogTitle>Stop Contact</DialogTitle>
      <DialogContent>Stop Contact for this lead (Unqualify). Continue?</DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={onSubmit} autoFocus>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StopContactDialog;
